var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var Badge_1 = __importDefault(require("./Badge"));
exports.Badge = Badge_1.default;
exports.default = Badge_1.default;
//# sourceMappingURL=index.js.map